import React from 'react'
import ModalCloseButton from 'components/modal/components/closeButton'
import 'styles/main.scss'

// The header of company's modals: the title at 24px, the close button a 40px
// square. It keeps its height while the body scrolls (structure.js).
const Modalheader = ({children,hide,hideShow}) => {

    return (
        <div className="flex flex-shrink-0 items-center justify-between gap-4 px-6 pt-8 rounded-t">
            <h3 className="text-2xl leading-[30px] text-[#202124] font-medium">
                {children}
            </h3>
            {hideShow ?
                <ModalCloseButton onClick={hide} className="ml-auto"/>
                : ''}
        </div>
    )
}

export default Modalheader
